module.exports = __webpack_public_path__ + "static/media/example-05.6d36e240.jpg";